export default __webpack_public_path__ + "d253ba3621a139c9ae41aca3ffcfa68f.png";